/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Field_EmailInputs */

const tr_contact_form_field_email = /** @type {(inputs: Contact_Form_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta *`)
};

const en_contact_form_field_email = /** @type {(inputs: Contact_Form_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email *`)
};

const de_contact_form_field_email = /** @type {(inputs: Contact_Form_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail *`)
};

const ru_contact_form_field_email = /** @type {(inputs: Contact_Form_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта *`)
};

/**
* | output |
* | --- |
* | "Email *" |
*
* @param {Contact_Form_Field_EmailInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_field_email = /** @type {((inputs?: Contact_Form_Field_EmailInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Field_EmailInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_field_email(inputs)
	if (locale === "de") return de_contact_form_field_email(inputs)
	if (locale === "ru") return ru_contact_form_field_email(inputs)
	return tr_contact_form_field_email(inputs)
});